import React, { useState } from 'react';

import { Modal } from '@breezeventures/ui-kit/modal';
import { Typography } from '@breezeventures/ui-kit/typography';

import { MenuProps } from './types';

export const MobileMenu = ({ trigger, items }: MenuProps) => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      {React.cloneElement(trigger, {
        onClick: (event: React.MouseEvent) => {
          trigger.props.onClick?.(event);
          setOpened(true);
        },
      })}

      <Modal opened={opened} onClose={() => setOpened(false)}>
        <div className="pt-2">
          {items.map((item, index) => (
            <React.Fragment key={item.key}>
              {index > 0 && (
                <hr className="mx-4 my-0 border-t border-gray-200" />
              )}
              <button
                type="button"
                onClick={() => {
                  setOpened(false);
                  item.onClick();
                }}
                className={`
                  flex w-full items-center gap-3 rounded-md px-4 py-3 text-left
                  transition-colors
                  hover:bg-neutral-1
                `}
              >
                <span className="size-5 shrink-0">{item.icon}</span>
                <Typography.Text size="m" color="primary">
                  {item.label}
                </Typography.Text>
              </button>
            </React.Fragment>
          ))}
        </div>
      </Modal>
    </>
  );
};
